import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useFormik } from 'formik';
import TextField from '@mui/material/TextField';
import ReactLoading from 'react-loading';
import { GiveCodeSchema } from '../schemas';
import { useNavigate, useLocation } from 'react-router-dom';
import mode from './Mode';
import '../styles/resetPassword.css';

const GiveCode = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [formMessage, setFormMessage] = useState({ type: '', text: '' });
    const navigate = useNavigate();
    const { state } = useLocation();
    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/general/' : 'http://127.0.0.1:8000/general/';
    const email = state?.email || sessionStorage.getItem('resetEmail');
    const [otpId, setOtpId] = useState(null);

    useEffect(() => {
        if (!email) {
            navigate('/reset-give-email');
        }

        const storedOtpId = sessionStorage.getItem('otpId');
        if (storedOtpId) {
            setOtpId(storedOtpId);
        } else {
            setFormMessage({ type: 'error', text: 'Session expired. Please request a new code.' });
            setTimeout(() => navigate('/reset-give-email'), 2000);
        }
    }, [email, navigate]);

   const onSubmit = () => {
        setIsLoading(true);
        setFormMessage({ type: '', text: '' });

        axios.post(baseurl + 'confirm-otp/', {
            otp: values.code,
            email: email,
            id: parseInt(otpId)
        }).then((resp) => {
            setFormMessage({ type: 'success', text: 'Code verified successfully!' });
            
            sessionStorage.removeItem('otpId');
            sessionStorage.removeItem('resetEmail');
            
            setTimeout(() => {
                setIsLoading(false);
                navigate('/reset-password', { state: { email: email } });
            }, 2000);
            
        }).catch((err) => {
            setIsLoading(false);
            
            if (err.response) {
                if (err.response.status === 400) {
                    setFormMessage({ type: 'error', text: err.response.data.Error || 'Invalid OTP. Please try again.' });
                } else if (err.response.status === 404) {
                    setFormMessage({ type: 'error', text: 'OTP record not found. Please request a new code.' });
                    setTimeout(() => navigate('/reset-give-email'), 2000);
                } else {
                    setFormMessage({ type: 'error', text: 'An error occurred. Please try again.' });
                }
            } else {
                setFormMessage({ type: 'error', text: 'Network error. Please try again.' });
            }
        });
    };


    const { values, errors, handleBlur, touched, handleChange, handleSubmit } = useFormik({
        initialValues: {
            code: '',
        },
        validationSchema: GiveCodeSchema,
        onSubmit
    });

    return (
        <div className='reset-password-container'>
            <div className="reset-password-wrapper">
                <div className="reset-password-header">
                    <h1>Enter Verification Code</h1>
                    <p>A verification code has been sent to your email.</p>
                </div>

                <form method="POST" className='reset-password-form' onSubmit={handleSubmit}>
                    {formMessage.text && (
                        <div className={`form-message ${formMessage.type}`}>
                            {formMessage.text}
                        </div>
                    )}
                    <div className='form-group'>
                        <label htmlFor="code">Verification Code</label>
                        <TextField
                            fullWidth
                            required
                            error={!!(errors.code && touched.code)}
                            id="code"
                            variant="outlined"
                            name='code'
                            value={values.code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                            placeholder="Enter the 6-digit code"
                            inputProps={{ maxLength: 6 }}
                        />
                        {errors.code && touched.code && <p className='error-text'>{errors.code}</p>}
                    </div>


                    <button className="reset-password-btn" type="submit" disabled={isLoading}>
                        {isLoading ? <ReactLoading type="spin" color="#fff" height={25} width={25} /> : "Verify Code"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default GiveCode;